import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'textInQuotes',
    standalone: true
})
export class TextInQuotesPipe implements PipeTransform {

  transform(value: string, prefix: string): string {
    if (!value) {
      return '';
    }

    const first_nonquote_character = value.indexOf('"') + 1;
    const last_nonquote_character = value.lastIndexOf('"');

    let result = value.substring(first_nonquote_character, last_nonquote_character);

    if (result) {
      result = prefix + result;
    }

    return result;
  }
}
